import OBase from './OBase';
import * as Geometry from '../geometry';

// next用のコンポーネント
// エラーが出ないようにダミーのupdateを定義しておく
export default class ESelectable extends OBase {
    update(){
        const geomInputTree = this.getObjectInput('geometry');
        const output = this.getGenericObjectOutput('geometry');

        output.value = geomInputTree;
    }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ESelectable.js